import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import copyToClipboard from "../../../../util/copyToClipboard";
import { CheckIcon, ShareIcon } from "../Icons.jsx";
import s from "./ShareButton.module.css";

export default function ShareButton({ productName, url }) {
  const [copied, setCopied] = useState(false);

  const handleShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: productName,
          url,
        });
        return;
      } catch {
        // User cancelled or share failed — fall through to copy
      }
    }

    const success = await copyToClipboard(url);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [productName, url]);

  return (
    <button
      type="button"
      className={s.shareBtn}
      onClick={handleShare}
      aria-label={copied ? "Link copied" : `Share ${productName}`}
    >
      {copied ? <CheckIcon /> : <ShareIcon />}
    </button>
  );
}

ShareButton.propTypes = {
  productName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
